import React from 'react';
import CustomTooltip from '../Assets/customTheme/customtooltip';

/**
 * Common tooltip wrapper component for consistent tooltip usage across the application
 * @param {string} title - The tooltip text to display
 * @param {React.ReactNode} children - The element to wrap with tooltip
 * @param {string} placement - Tooltip placement (top, bottom, left, right). Default: 'top'
 * @param {boolean} arrow - Whether to show arrow. Default: true
 * @param {string} className - Additional CSS classes
 * @returns {JSX.Element} A tooltip-wrapped element
 */
export const renderTooltip = ({ 
  title, 
  children, 
  placement = 'top', 
  arrow = true,
  className = '' 
}) => {
  return (
    <CustomTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      className={className}
    >
      {children}
    </CustomTooltip>
  );
};

/**
 * Common tooltip wrapper component (as a React component)
 * Can be used directly in JSX
 */
export const CommonTooltip = ({ 
  title, 
  children, 
  placement = 'top', 
  arrow = true,
  className = '' 
}) => {
  return (
    <CustomTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      className={className}
    >
      {children}
    </CustomTooltip>
  );
};

export default renderTooltip;

